import { l } from '../../lib/imports'
import { mathUtils } from '../../lib/mathUtils-sidecar'
import { common } from '../../main/common-sidecar'
import { voyageCamera } from './voyageCamera-sidecar'
import { voyageGameManager } from './voyageGameManager-sidecar'

export interface IVoyageCameraZoomer {}

let _obj: IVoyageCameraZoomer | null = null
export function get() {
  if (!_obj) {
    _obj = create()
  }
  return _obj
}

const _zooms = [0.25, 0.5, 0.75, 1, 1.5, 2, 3, 4]
let _zoomIdx = l.findIndex(_zooms, (c) => c === 1)

function create() {
  let obj: IVoyageCameraZoomer = {}

  let s = common.getPhaserScene()
  s.input.on(
    'wheel',
    (
      _pointer: any,
      _gameObjects: any,
      _deltaX: number,
      deltaY: number,
      _deltaZ: number,
    ) => {
      if (voyageGameManager.get().mode === 'game') {
        onWheel(deltaY)
      }
    },
  )

  return obj
}

export function onWheel(deltaY: number) {
  // console.log(
  //   'camera zoomer mouse wheel',
  //   deltaY,
  //   '' + voyageGameManager.get().mode,
  //)

  if (deltaY > 0) {
    _zoomIdx--
  }
  if (deltaY < 0) {
    _zoomIdx++
  }
  _zoomIdx = mathUtils.clamp(_zoomIdx, 0, _zooms.length - 1)
  voyageCamera.setZoom(_zooms[_zoomIdx])
}

export function update() {
  let obj = get()
}
